// extracted by mini-css-extract-plugin
export default {"benefit":"lsyAv","row":"TfxOT","column":"ox8Mk","icon":"nAo9W","title":"sPfOW","description":"iAjwV","link":"WxVgi"};